import React from "react";
import { Link } from "react-router-dom";
import Button from "../../staff/Button";

export function EmailTemplatesBreadcrumbActions (): React.ReactElement {
  return (
    <div className="flex flex-wrap items-center gap-2 flex-shrink-0 w-full md:w-auto">
      <div className="w-full min-w-0 md:w-auto">
        <Link to="/send-email" className="block w-full md:w-auto">
          <Button
            text="Send emails"
            color="secondary"
            variant="filled"
            size="fixed"
            onClick={() => { }}
            className="w-full md:w-auto"
          />
        </Link>
      </div>
    </div>
  );
}
